<template>
	<Modals
		:title="title"
		:validateBeforeClose="validateBeforeClose"
		:display="display"
		@show="closeGlobalFormModal"
		:parentTag="'form'"
		:novalidate="'novalidate'"
	>
		<template #modal-content>
			<div class="change-reason">
				<div class="change-reason__comment">
					<Textarea
						:label="labelText"
						:placeholder="placeholder"
						:rows="4"
						:cols="30"
						:maxLength="maxLength"
						v-model="message"
						:required="required"
					/>
				</div>
			</div>
		</template>
		<template v-slot:modal-footer>
			<ButtonGroup
				:items="[
					{
						className: 'btn--primary',
						labelText: labelButtons.accept,
						disabled: !hasComment,
						btnClick: acceptAction
					},
					{
						className: 'btn--link',
						labelText: labelButtons.cancel,
						btnClick: cancelAction
					}
				]"
			/>
		</template>
	</Modals>
</template>

<script>
import Modals from '@/components/shells/modal/modals';
import Textarea from '@/components/forms/textarea/textarea.vue';
import ButtonGroup from '@/components/forms/button/button-group';

export default {
	name: 'ChangeReasonModal',
	components: {
		Modals,
		Textarea,
		ButtonGroup
	},
	model: {
		prop: 'display',
		event: 'show'
	},
	props: {
		title: {
			type: String,
			default: ''
		},
		parentTag: {
			type: String,
			default: 'div'
		},
		validateBeforeClose: {
			type: Boolean,
			default: false
		},
		display: {
			type: Boolean,
			default: false
		},
		required: {
			type: Boolean,
			default: false
		},
		labelText: {
			type: String,
			default: ''
		},
		placeholder: {
			type: String,
			default: ''
		},
		maxLength: {
			type: Number,
			default: 300
		},
		labelButtons: {
			type: Object,
			default: () => {
				return { accept: 'Restore', cancel: 'Cancel' };
			}
		}
	},
	data() {
		return {
			message: ''
		};
	},
	computed: {
		hasComment() {
			return !!this.message;
		}
	},
	methods: {
		closeGlobalFormModal() {
			if (!this.validateBeforeClose) {
				this.message = '';
				this.$emit('show', false);
			}
		},
		acceptAction() {
			this.$emit('message', this.message);
			this.closeGlobalFormModal();
		},
		cancelAction() {
			this.closeGlobalFormModal();
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    * Global Forms Change Reason Modal
    * Can use SCSS variables = TRUE
*/

.modal__footer {
	.btn-set {
		> * {
			&:not(:last-child) {
				margin-right: $gutter-lg;
			}
			@include mq($until: lg) {
				&:not(:last-child) {
					margin-right: $gutter-lg;
				}
			}
		}

		.btn {
			&--small:nth-last-child(n + 2),
			&--small:nth-last-child(n + 2) ~ .btn--small {
				@include mq($until: lg) {
					&:not(:last-child) {
						margin-right: $gutter-lg;
					}
				}
			}
		}
	}
}

.change-reason {
	@include mq($from: md) {
		width: 580px;
	}
}

.modal__footer {
	text-align: right;
	margin-top: $gutter-lg;
	z-index: 1;
}

.modal--full-mobile {
	max-width: 100%;
	width: 100%;
	height: 100vh;
	max-height: 100vh;
	border-radius: 0;

	.modal__body {
		max-height: 80vh;

		@include mq($from: lg) {
			max-height: 70vh;
		}
	}

	.modal__footer {
		@include mq($from: md) {
			bottom: 0;
			right: 0;
			position: initial;
		}
	}
}
</style>
